import Vue from 'vue';

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

Vue.component('super-oferta', require('./components/SuperOferta.vue').default);

new Vue({
  el: '#oferta',
});



// WEBPACK FOOTER //
// ./scripts/oferta.js